export default __webpack_public_path__ + "static/making-tired-c2632f8368867b10ed2131fffc9a7708.svg";